import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import userAuthReducer from "../app/Pages/Login/store/login.Slice";
import DrawerReducer from "../app/Components/AppDrawer/store/AppDrawerSlicer";
import NotificationSlicer from "./Slices/index";
import OnioSlicer from "./Slices/appSlicer";
import LocksSlicer from './Pages/Security/store/locksSlicer'
import garageSlicer from "./Pages/Security/store/Garage/garageSlicer";
import gateSlicer from './Pages/Security/store/Gates/gatesSlicer'
import logoutSlicer from "./Pages/Logout/logoutSlicer";


export const store = configureStore({
  reducer: {
    counter: counterReducer,
    userAuth: userAuthReducer,
    drawer: DrawerReducer,
    NotificationSlicer: NotificationSlicer,
    OnioSlicer: OnioSlicer,
    locks: LocksSlicer,
    garages: garageSlicer,
    gates: gateSlicer,
    logoutModal: logoutSlicer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
